export default __webpack_public_path__ + "static/media/Upload.bc9b629b.svg";